export const Errors = {
  error400: "Petición incorrecta.",
  error401: "Se requiere autenticación.",
  error401Description:
    "La sesión ha expirado. Por favor, vuelve a iniciar sesión para continuar.",
  error403: "Sin autorización.",
  error403Description: "No estás autorizado para acceder a esta funcionalidad.",
  error404: "Recurso no encontrado.",
  error405: "Acción no permitida.",
  error408: "Se ha acabado el tiempo de respuesta.",
  error409: "Se ha generado un conflicto.",
  error410: "El recurso ya no se encuentra disponible.",
  error422: "No se puede procesar la petición.",
  error429: "Se han realizado demasiadas peticiones.",
  error500: "Error interno del servidor.",
  error501: "Método no reconocido.",
  error502: "Puerta de enlace no válida.",
  error503: "Servicio no disponible.",
  error504: "Se ha acabado el tiempo de respuesta.",
  generic: "¡Ups! algo ha salido mal.",
  fallbackMessage: "Por favor recarga la página o vuelve atrás.",
  NotFound: "El recurso solicitado no se ha encontrado.",
  Unauthorized: "No estás autorizado para realizar esta acción.",
  Forbidden: "No tienes permiso para acceder a este recurso.",
  BadRequest: "La petición no es válida o no se puede atender.",
  Conflict: "La petición no se pudo completar debido a un conflicto.",
  WATCHLIST_IN_USE:
    "Esta lista de interés está asignada a un disparador de eventos y no puede ser eliminada.",
  InternalServerError: "Se ha producido un error interno del servidor.",
  ServiceUnavailable: "El servicio no está disponible en este momento.",
  TooManyRequests:
    "Se han realizado demasiadas peticiones. Por favor, inténtalo de nuevo más tarde.",
  UnknownError: "Se ha producido un error desconocido.",
};
